goog.module('yext.storm.LocationTooltip');
goog.module.declareLegacyNamespace();

/**
 * This is intended to control a tooltip that contains a list of locations.
 *
 * This tooltip is intended to be a single DOM element whose content changes
 * as necessary. The tooltip will also be repositioned as necessary. The
 * tooltip should have class 'location-tooltip'.
 *
 * The tooltip is expected to contain:
 *   - a node with class 'location-tooltip-title'
 *   - a node with class 'location-tooltip-arrow'
 *   - a node with class 'location-tooltip-content'
 *   - a node with class 'location-tooltip-search'
 *   -   an input within the search object
 *
 * See post.html for an example.
 *
 * Usage: var tooltip = new LocationTooltip($('selector'))
 *
 * @author Vincent Le (vple@yext.com)
 */


/**
 * @constructor
 */
const LocationTooltip = function(element) {
  this.init(element);
  this.bindHide();
};

/**
 * Initiates the tooltip. Finds several elements used throughout the class.
 *
 * @param {!Object} element - the root node of the tooltip
 */
LocationTooltip.prototype.init = function(element) {
  var $element = $(element);
  this.tooltip = $element;
  this.title = $element.find('.location-tooltip-title');
  this.arrow = $element.find('.location-tooltip-arrow');
  this.content = $element.find('.location-tooltip-content');
  this.search = $element.find('.location-tooltip-search');
  this.$positioner = undefined;
  this.inverted = false;
};

/**
 * Shows the tooltip.
 */
LocationTooltip.prototype.show = function() {
  this.tooltip.show();
  return this;
};

/**
 * Hides the tooltip.
 */
LocationTooltip.prototype.hide = function() {
  this.tooltip.hide();
  return this;
};

/**
 * Shows or hides the search element.
 *
 * @param {boolean} showSearch - shows the search node if true, otherwise
 *   hides the search node
 */
LocationTooltip.prototype.toggleSearch = function(showSearch) {
  this.search.toggle(showSearch);
};

/**
 * Hides the tooltip when the user clicks outside of the tooltip or presses
 * escape.
 * @suppress {deprecated}
 */
LocationTooltip.prototype.bindHide = function() {
  var that = this;
  $(document).bind('click.locationTooltip keydown.locationTooltip', function(e) {
    if ($(e.target).closest(that.tooltip).length === 0) {
      if (e.type == 'keydown' && e.keyCode == $.ui.keyCode.ESCAPE
          || e.type == 'click' && $(e.target).parents('#social-tooltip').length == 0) {
        that.search.find('input').val('');
        that.hide();
      }
    }
  });
};

/**
 * Sets the title of the tooltip.
 * @param {string} text - New title text.
 */
LocationTooltip.prototype.setTitle = function(text) {
  this.title.text(text);
};

/**
 * Positions the tooltip at $element. Does not show/hide the tooltip.
 *
 * Note that the tooltip should be shown before positioning (otherwise there
 * may be an issue with the arrow).
 *
 * @param {!jQuery} $element - Object at which to position the tooltip.
 */
LocationTooltip.prototype.position = function($element, isReposition) {
  this.$positioner = $element;

  var position = {
    my: 'center top',
    at: 'center bottom',
    of: $element,
    offset: '100 5',
    collision: 'fit flip',
  };

  if (isReposition) {
    position['collision'] = 'fit none';
    if (this.inverted) {
      position['my'] = 'center bottom';
      position['at'] = 'center top';
      position['offset'] = '100 -5';
    }
  }
  this.tooltip.position(position);

  var arrow = this.arrow;
  arrow.removeClass('invert');
  var arrowPosition = {
    my: 'center top',
    at: 'center bottom',
  };

  if (!isReposition) {
    this.inverted = this.tooltip.offset().top < $element.offset().top;
  }

  if (this.inverted) {
    arrowPosition = {
      my: 'center bottom',
      at: 'center top',
    };
    arrow.addClass('invert');
  }

  arrow.position({
    'my': arrowPosition.my,
    'at': arrowPosition.at,
    'offset': '0 0',
    'of': $element,
    'collision': 'none',
  });

  return this;
};

/**
 * Repositions based on the last element that it was positioned to
 */
LocationTooltip.prototype.reposition = function() {
  this.position(this.$positioner, true);
};

/**
 * Sets the tooltip content.
 * @param {string} html - New content to display in the tooltip.
 */
LocationTooltip.prototype.setContent = function(html) {
  this.content.html(html);
};

exports = LocationTooltip;
